export default __webpack_public_path__ + "static/media/awaiting6S.d95e5171.svg";